module.exports = __webpack_public_path__ + "static/img/Dashboard.3211aa9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/backoffice/Dashboard.png
// module id = 5eI7
// module chunks = 0